export default "__VITE_ASSET__GJZk0Gow__"